/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Check_In_ForbiddenInputs */



/**
* | output |
* | --- |
* | "Only organizers or the player themselves can check in" |
*
* @param {Err_Tournament_Check_In_ForbiddenInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_check_in_forbidden = /** @type {((inputs?: Err_Tournament_Check_In_ForbiddenInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Check_In_ForbiddenInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seuls les organisateurs ou le joueur lui-même peuvent pointer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo los organizadores o el propio jugador pueden hacer el check-in")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Somente organizadores ou o próprio jogador podem fazer o check-in")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo gli organizzatori o il giocatore stesso possono fare il check-in")
	return /** @type {LocalizedString} */ ("Only organizers or the player themselves can check in")
});